export default "__VITE_ASSET__XlMEsDO3__"